<!-- 实时库存页面 -->
<template>
  <div class="app-container">
    <el-card>
      <el-tabs v-model="activeName">
        <el-tab-pane
          v-for="(item, index) in warehouse"
          :key="item.warehouseId"
          :label="item.warehouseName"
          :name="item.warehouseId"
        >
          <InventoryTable :data="item" :activeName="activeName" />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script setup>
import { ref } from "vue";
import InventoryTable from "./inventoryTable";
import useCacheStore from "@/store/modules/cache";

const cacheStore = useCacheStore();
const warehouse = cacheStore.warehouse;

const activeName = ref(warehouse[0].warehouseId);
</script>

<style lang="scss" scoped></style>
